class SigninService {
  constructor(SecurityApiService, SecurityService) {
    'ngInject';

    this.SecurityApiService = SecurityApiService;
    this.SecurityService = SecurityService;
  }

  signin(payload) {
    return this.SecurityService.login(payload);
  }
}

export default SigninService;



// WEBPACK FOOTER //
// ./client/app/pages/signin/service/signin.service.js